import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X, Eye } from "lucide-react";

export function ImpersonationBanner() {
  const { impersonatedTenant, isImpersonating, stopImpersonation } = useImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedTenant) {
    return null;
  }

  const handleExit = () => {
    stopImpersonation();
    navigate("/platform-admin/tenants");
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-primary text-primary-foreground px-4 py-2 flex items-center justify-between shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
      <div className="flex items-center gap-3">
        <Eye className="h-4 w-4" />
        <span className="text-sm font-medium">
          Stai visualizzando come: <strong>{impersonatedTenant.name}</strong>
        </span>
      </div>
      <Button
        variant="secondary"
        size="sm"
        onClick={handleExit}
        className="gap-2"
      >
        <X className="h-4 w-4" />
        Esci da impersonazione
      </Button>
    </div>
  );
}
